import { useEffect, useRef,useState} from "react";
import {getLingua, getToken, getUserId} from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/agenda.css"
import "../stili/agenda_preont.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {
    convertiIdInventario,
    ordinaPerData,
    camereDisponibili,
    prendiNomePacchetto,
    coloreDaId,
    pacchettiAperti,
    materialeDisponibile,
    istruttori_disponibili,
    isoToString,
    convertiValuta,
    convertiStruttura
} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
import { RRule, rrulestr } from 'rrule';
import meteo from "../funzioni/previsionimeteo"
import {dizionarioTraduzioni} from "../funzioni/traduzioni";
/* global $ */
function AgendaPrenotazioni(){
    const lingua=getLingua()
let baseFormItems = null;
function cloneItems(items) {
    return items.map(item => {
        const copy = { ...item };
        if (item.items) copy.items = cloneItems(item.items);
        return copy;
    });
}

function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
useEffect(() => {
    $("#schedulerElementPrenotazioni").dxScheduler({
      dataSource: [],
      views: [
  {
        name: 'Mensile', type: 'timelineMonth', maxAppointmentsPerCell: "unlimited",
      },

],
      currentView: 'timelineMonth',
        resources: [{
        fieldExpr: "roomid",
        dataSource: [],
        label: "Istruttore"
      }],
      currentDate: new Date(),
       timeZone: "UTC",
      editing: {
           allowDragging: false,
    allowResizing: false,
  allowAdding: true,
  allowDeleting: true,
  allowUpdating: true,
          cellDuration: 120,
  allowRecurrence: true // ✅ questo è necessario per visualizzare e gestire le ricorrenze
},
      showAllDayPanel: false,
      crossScrollingEnabled: true,
      textExpr: 'text',

      onAppointmentFormOpening: async function (e) {
      $("#loadingOverlay").show()
  const originalData = { ...e.appointmentData };
  const form = e.form;

    // resetta i valori: prendi i dati dall'appuntamento
    form.option("formData", { ...e.appointmentData });

var ite=form.option('items')
  // Imposta la larghezza del popup
  e.popup.option('width', "80%");
  let ce=false
  for (let oggetto of form.option('items')){
    if (oggetto.name==="camereContainer"){
        ce=true
    }
  }
  const dateBoxS = e.form.option("formData").startDate;
      const dateBoxE = e.form.option("formData").endDate;
      const fine=DateTime.fromJSDate(dateBoxE).setZone('utc', { keepLocalTime: true })
      const inizio=DateTime.fromJSDate(dateBoxS).setZone('utc', { keepLocalTime: true })
      const durata=fine.startOf('day').diff(inizio.startOf('day'), 'days').days
      var minuti=durata%60
  if (ce){
    setTimeout(()=>{
    form.updateData("endDate",originalData.endDate)
    const dateBoxS = e.form.option("formData").startDate;
      const dateBoxE = e.form.option("formData").endDate;
      const fine=DateTime.fromJSDate(dateBoxE).setZone('utc', { keepLocalTime: true })
      const inizio=DateTime.fromJSDate(dateBoxS).setZone('utc', { keepLocalTime: true })
      const durata=fine.startOf('day').diff(inizio.startOf('day'), 'days').days

    form.updateData("val_durata",durata)},2)
  }

  if (!ce){
      form.option('items')[0].items[0].label.text=dizionarioTraduzioni(lingua,"Nome Prenotazione")
      ite[0].items[1].colCountByScreen.lg=3
      ite[0].items[1].colCountByScreen.xs=1

      ite[0].items[1].items.push({
  dataField: "val_durata",
  label: { text: "Durata" },
  editorType: "dxNumberBox",
  editorOptions: {
    min: 0,
    value:durata,
    format: `#' ${dizionarioTraduzioni(lingua,"Notti")}'`,
    onValueChanged: function(e) {
      const duration = e.value;
      const valoreInMs = duration * 60 * 60000 * 24;
      const inizio =DateTime.fromJSDate(form.getEditor("startDate").option("value")).setZone('utc', { keepLocalTime: true })
      const fine = inizio.plus({ milliseconds: valoreInMs });
      const fineJSDate = new Date(fine.year, fine.month - 1, fine.day, fine.hour, fine.minute, fine.second);
      if (fineJSDate!==form.getEditor("endDate").option("value"))
      form.updateData("endDate", fineJSDate)
      const camere = Object.keys(form.option("formData")).filter(k => k.startsWith("camera_"));
      for (let chiave of camere){
          const tipoCosto=`tipoCosto_${parseInt(chiave.replace("camera_",""))}`
          const costo_p=`costo_p_${parseInt(chiave.replace("camera_",""))}`
          const costo_totale=`costo_totale_${parseInt(chiave.replace("camera_",""))}`
          if (form.option("formData")[tipoCosto]===1){
                    const costoTotale=form.option("formData").val_durata*form.option("formData")[costo_p]
                    form.updateData(costo_totale, costoTotale)
          }
          else{
              const costoTotale=form.option("formData").costo_p
              form.updateData(costo_totale, costoTotale)
          }
      }
    }
  }
})

      ite[0].items[1].items[0].editorOptions.format= "dd/MM/yyyy"
      ite[0].items[1].items[0].editorOptions.displayFormat ="dd/MM/yyyy"
      ite[0].items[1].items[0].editorOptions.onValueChanged=function(e){
        const fine =DateTime.fromJSDate(form.getEditor("endDate").option("value")).setZone('utc', { keepLocalTime: true })
        const valoreOra=DateTime.fromJSDate(e.value).setZone('utc', { keepLocalTime: true })
        const durataTot=fine.startOf('day').diff(valoreOra.startOf('day'), 'days').days
        form.updateData("val_durata", durataTot)
      }
      ite[0].items[1].items[2].editorOptions.format= "dd/MM/yyyy"
      ite[0].items[1].items[2].editorOptions.displayFormat ="dd/MM/yyyy"
      ite[0].items[1].items[2].editorOptions.onValueChanged=function(e){
        const valoreOra =DateTime.fromJSDate(form.getEditor("startDate").option("value")).setZone('utc', { keepLocalTime: true })
        const fine=DateTime.fromJSDate(e.value).setZone('utc', { keepLocalTime: true })
        const durataTot=fine.startOf('day').diff(valoreOra.startOf('day'), 'days').days

        if (durataTot!==form.getEditor("val_durata").option("value"))
        form.updateData("val_durata", durataTot)
      }
      ite[0].items[1].items[2].editorOptions.type="date"
      ite[0].items[1].items[0].editorOptions.type="date"
      ite[0].items.splice(6,1)
      ite[0].items[2].items[0].editorOptions.onValueChanged=function(e){
      ite[0].items[2].items[0].editorOptions.value=e.value

      setTimeout(()=>{const valoreOra =DateTime.fromJSDate(form.getEditor("startDate").option("value")).setZone('utc', { keepLocalTime: true })
        const fine=DateTime.fromJSDate(form.getEditor("endDate").option("value")).setZone('utc', { keepLocalTime: true })
        const durataTot=fine.startOf('day').diff(valoreOra.startOf('day'), 'days').days
        form.updateData("val_durata", durataTot)},0)
      if (ite[0].items[1].items[0].editorOptions.format==="dd/MM/yyyy HH:mm"){

      ite[0].items[1].items[0].editorOptions.format= "dd/MM/yyyy"
      ite[0].items[1].items[0].editorOptions.displayFormat ="dd/MM/yyyy"
      ite[0].items[1].items[0].editorOptions.type="date"
      ite[0].items[1].items[2].editorOptions.format= "dd/MM/yyy"
      ite[0].items[1].items[2].editorOptions.type="date"
      ite[0].items[1].items[2].editorOptions.displayFormat ="dd/MM/yyyy"}
      else
      {ite[0].items[1].items[0].editorOptions.format= "dd/MM/yyyy HH:mm"
      ite[0].items[1].items[0].editorOptions.displayFormat ="dd/MM/yyyy HH:mm"
      ite[0].items[1].items[2].editorOptions.format= "dd/MM/yyyy HH:mm"
      ite[0].items[1].items[2].editorOptions.displayFormat ="dd/MM/yyyy HH:mm"
      ite[0].items[1].items[0].editorOptions.type="datetime"
      ite[0].items[1].items[2].editorOptions.type="datetime"

      }


      form.option('items',ite)}

      ite[0].items[2].items[0].editorOptions.value= true
if (getUserId()!=="34"){
    let elencoStrutture=[]
    let inizio=1
    const extraGroup = {
      itemType: 'group',
      colSpan: 2,
      name: 'extraContainer',
      caption: dizionarioTraduzioni(lingua,'Seleziona extra'),
      items: [
            {itemType: 'group',
      colSpan: 2,
      colCountByScreen:{lg: 2, xs: 1},
      name: 'transferBlock',
      caption: 'Transfer',
      items:[{
      itemType: 'group',
      colSpan: 2,
      name: 'transferBlock1',
      colCountByScreen:{lg: 2, xs: 1},
      items:[
      {
    dataField: "transfer",
    label: { text: "Transfer" },
    editorType: "dxCheckBox",
    editorOptions: {
        onValueChanged: function(e) {
            const visibile = e.value;
            form.itemOption("extraContainer.transferBlock.transferBlock1.destinazioneTransfer", "visible", visibile);
            form.itemOption("extraContainer.transferBlock.transferBlock2.incassoTransfer", "visible", visibile);
            form.itemOption("extraContainer.transferBlock.transferBlock2.costoTransfer", "visible", visibile);
            form.itemOption("extraContainer.transferBlock.transferBlock2.pagatoTransfer", "visible", visibile);
        }
    }
},
{
    dataField: "destinazioneTransfer",
    label: { text: "Destinazione Transfer" },
    editorType: "dxTextBox",visible: false
},

      ]},
      {
      itemType: 'group',
      colSpan: 2,
      name: 'transferBlock2',
      colCountByScreen:{lg: 3, xs: 1},
      items:[
      {
    dataField: "incassoTransfer",
    label: { text: "Incasso Transfer" },
    editorType: "dxNumberBox",
    visible: false,
    editorOptions: { format: "#0.##'€'" }
},
{
    dataField: "costoTransfer",
    label: { text: "Costo Transfer" },
    editorType: "dxNumberBox",
    visible: false,
    editorOptions: { format: "#0.##'-/'" }
},
{
    dataField: "pagatoTransfer",
    label: { text: "Anticipo Transfer" },
    editorType: "dxNumberBox",
    visible: false,
    editorOptions: {
    format: "#0.##'€'" }
},
      ]}
      ]}
      ]
    }
    ite.splice(3, 0,extraGroup)
}
    const camereGroup = {
      itemType: 'group',
      colSpan: 2,
      name: 'camereContainer',
      caption: dizionarioTraduzioni(lingua,'Camere e Ospiti'),
      items: [
        {
          itemType: 'button',
          horizontalAlignment: 'left',
          buttonOptions: {
            text: `+ ${dizionarioTraduzioni(lingua,'Aggiungi camera')}`,
            type: 'default',
            onClick: function () {
              aggiungiCamera(0,[],60,0,0);
            }
          }
        }
      ]
    };

    ite.push(camereGroup);

    // Applica il nuovo item
    form.option('items', ite);
}
if (e.appointmentData.id){
    let camereTot=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLinkBookingRooms",
                filtri:{"bookingid":e.appointmentData.id}
            })
    let ospitiTot=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBookingGuests",
            })
    let extra=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBookingExtras",
                filtri:{"bookingid":e.appointmentData.id}
            })
    for (let extras of extra){
        if (extras.extratype===1){form.updateData("transferid",extras.extraid)
        }
    }
    if (extra.length){
        form.updateData("transfer",true)

        form.updateData("destinazioneTransfer",extra[0].extravalue1)
        form.updateData("incassoTransfer",extra[0].extracost)
        form.updateData("pagatoTransfer",extra[0].extrapaid)
        form.updateData("costoTransfer",extra[0].extracostus)
    }
    for (let i of camereTot){
        let ospitiCamera=[]
        for (let ospiti of ospitiTot){
            if (ospiti.linkbookroomid===i.linkbookroomid){
                ospitiCamera.push(ospiti)
            }
        }
        aggiungiCamera(i.roomid,ospitiCamera,(i.linkbookroomcost/form.option("formData").val_durata),i.linkbookroomadvance,i.linkbookroomid,i.linkbookroomcurrency,i.linkbookroompaymentmethod,i.linkbookroompaymentdate)
    }
}
// Logica per aggiungere camere
async function aggiungiCamera(numeroCamera,ospitiCamera,costoG,anticipo,linkbookroomid,valuta,metodopag,datapag)  {
  const camereGroup = form.itemOption("camereContainer");
  const camereItems = camereGroup.items;

  // Gruppo per una nuova camera
  let data1 = form.option('formData').startDate;
  let data2 = form.option("formData").endDate;
  data1 = DateTime.fromJSDate(data1).setZone('utc', { keepLocalTime: true }).toMillis();
  data2 = DateTime.fromJSDate(data2).setZone('utc', { keepLocalTime: true }).toMillis();
  let camere = await camereDisponibili(data1, data2,numeroCamera);

let globalCameraCounter = form.option("globalCameraCounter") || 0;
  globalCameraCounter++;
  form.option("globalCameraCounter", globalCameraCounter);

  const cameraIdGen = globalCameraCounter;
 let nuoviNumeri = []
for (let oggetto of camereItems){
    if (oggetto.name){
        const numeroOr = parseInt(oggetto.name.split("_")[1])
        nuoviNumeri.push(parseInt(($(`#cameraTitle_${numeroOr}`).text()).split(".")[1]))
    }
 }
 const cameraId=nuoviNumeri.length?Math.max(...nuoviNumeri) + 1:1
  let formData = form.option("formData");
  let ospitiGia=[]
  formData[`camera_${cameraIdGen}`]=numeroCamera!==0?numeroCamera:null
  let contatore2=0
  for (let ospite of ospitiCamera){
     ospitiGia.push({"id":contatore2,"luogoNascita":ospite.guestbirthplace,"dataNascita":ospite.guestbirthdate,"numeroPassaporto":ospite.guestdocnumber,"tipoDoc":ospite.guestdoctype,"guestid":ospite.guestid,"nome":ospite.guestname,"cognome":ospite.guestsurname,"nazionalita":ospite.guestnationality,"sesso":ospite.guestsex,"linkbookroomid":ospite.linkbookroomid})
    contatore2++
  }
  formData[`ospiti_${cameraIdGen}`] = ospitiGia;
  formData[`linkbookroomid_${cameraIdGen}`] = linkbookroomid
  form.option("formData", formData);

  // Unico blocco custom (selectbox + tabella + pulsante)
  const cameraBlock = {
    itemType: "custom",
    name: `cameraBlock_${cameraIdGen}`,
    template: function (data, itemElement) {
    const copiaNumero=cameraId
    const container = $("<div>").addClass("camera-block").appendTo(itemElement);
      itemElement.data("containerRef", container);

      // Riga header con titolo + cestino
      const header = $("<div>").addClass("camera-header").css({
        display: "flex",
        "justify-content": "space-between",
        "align-items": "center",
        "margin-bottom": "5px",
      }).appendTo(container);

      $("<span>").attr("id", `cameraTitle_${cameraIdGen}`)
        .text(`${dizionarioTraduzioni(lingua,"Camera N.")} ${copiaNumero}`)
        .css({ "font-weight": "bold","font-size":"16px" })
        .appendTo(header);

      $("<div>").attr("id", `removeBtn_${cameraIdGen}`).dxButton({
        icon: "trash",
        type: "danger",
        stylingMode: "text",
        onClick: function() {
          rimuoviCamera(`cameraBlock_${cameraIdGen}`);
        }
      }).appendTo(header);

      // SelectBox Camera
      $("<div>").attr("id", `selectCamera_${cameraIdGen}`).dxSelectBox({
        dataSource: camere,
        value: formData[`camera_${cameraIdGen}`],
        displayExpr: "roomdescr",
        valueExpr: "roomid",
        onValueChanged: function(e) {
          const fd = form.option("formData");
          fd[`camera_${cameraIdGen}`] = e.value;
          form.option("formData", fd);
          for (let cameraSc of camere){
              if (cameraSc.roomid===e.value){
                  form.updateData("struttura",cameraSc.roomstructure)
              }
          }
          console.log(form.option("formData"))

        }
      }).appendTo(container);

      // Tabella Ospiti
      $("<div>").attr("id", `ospitiGrid_${cameraIdGen}`).dxDataGrid({
        dataSource: formData[`ospiti_${cameraIdGen}`],
        keyExpr: "id",
        columnAutoWidth: true,
      columnHidingEnabled: true,
        columns: [
          { dataField: "nome", caption: dizionarioTraduzioni(lingua,"Nome"),hidingPriority:7 },
          { dataField: "guestid", caption: "idCliente",visible:false },
          { dataField: "cognome",hidingPriority:8, caption: dizionarioTraduzioni(lingua,"Cognome") },
          { dataField: "luogoNascita",hidingPriority:4, caption: dizionarioTraduzioni(lingua,"Luogo di Nascita") },
          { dataField: "dataNascita",hidingPriority:5, caption: dizionarioTraduzioni(lingua,"Data di Nascita") },
          { dataField: "sesso", caption: dizionarioTraduzioni(lingua,"Genere"),hidingPriority:1,customizeText: function (e) {
            if (e.value===0) return dizionarioTraduzioni(lingua,"Uomo")
            else return dizionarioTraduzioni(lingua,"Donna")
          }
          ,editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_sex").length===0) {
                $('<div id="val_sex"></div>').appendTo(cellElement)
            }
            const dati_id_c=[{ID:0,name:"Uomo"},{ID:1,name:"Donna"},]
            $("#val_sex").dxSelectBox({dataSource: dati_id_c,displayExpr:"name",valueExpr:"ID",

            onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              }
            },)

          } },
          { dataField: "nazionalita",hidingPriority:2, caption: dizionarioTraduzioni(lingua,"Nazionalità") },
          { dataField: "tipoDoc",hidingPriority:3, caption: dizionarioTraduzioni(lingua,"tipo Documento"),
          customizeText: function (e) {
            if (e.value===1) return dizionarioTraduzioni(lingua,"Passaporto")
            else if (e.value===2) return dizionarioTraduzioni(lingua,"Carta d'identità")
            else return dizionarioTraduzioni(lingua,"Patente")
          },
          editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_doc").length===0) {
                $('<div id="val_doc"></div>').appendTo(cellElement)
            }
            const dati_id_c=[{ID:1,name:dizionarioTraduzioni(lingua,"Passaporto")},{ID:2,name:dizionarioTraduzioni(lingua,"Carta d'identità")},{ID:3,name:dizionarioTraduzioni(lingua,"Patente")},]
            $("#val_doc").dxSelectBox({dataSource: dati_id_c,displayExpr:"name",valueExpr:"ID",

            onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              }
            },)

          } },
          { dataField: "numeroPassaporto",hidingPriority:6, caption: dizionarioTraduzioni(lingua,"Numero Documento") }
        ],
        editing: {
          mode: "popup",
          allowAdding: true,
          allowUpdating: true,
          allowDeleting: true,popup: {
            height:"auto",
            maxHeight:"90%",
            title: `Modifica ospite`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "nome","cognome","dataNascita","luogoNascita","sesso","nazionalita","tipoDoc","numeroPassaporto",
                ],
              },]}
        },
        onRowInserting: function(e){
          e.data.id = new Date().getTime();
          form.option("formData", formData);
        }
      }).css("margin-top", "10px").appendTo(container);
    }
  };
  camereItems.splice(camereItems.length - 1, 0, cameraBlock);
  let mapValute=[]
    let inizio=0
    while (convertiValuta(inizio)){
      mapValute.push({ID:inizio,text:convertiValuta(inizio)})
        inizio+=1
    }
  const anticipoBox={ colCountByScreen:{lg: 2, xs: 1},
        colSpan:2,
        itemType:"group",
        name: `gruppoAnticipo_${cameraIdGen}`,
        items:[
          {
        dataField: `pagato_${cameraIdGen}`,
        label:{text:dizionarioTraduzioni(lingua,"Pagato")},
          editorType: "dxNumberBox",
          editorOptions: {
          value:anticipo,
          format:"#0.##'€'",
          }},
            {
        dataField: `valuta_${cameraIdGen}`,
        label:{text:dizionarioTraduzioni(lingua,"Valuta")},
          editorType: "dxSelectBox",
          editorOptions: {
          dataSource:mapValute,
              value:valuta?valuta:0,
              valueExpr:"ID",
              displayExpr:"text",
              onValueChanged:function(e){
                form.updateData(`valuta_${cameraIdGen}`,e.value)
                  const nuovaValuta = convertiValuta(e.value);

            // Costo per unità
            const costoEditor = form.getEditor(`costo_p_${cameraIdGen}`);
            if (costoEditor) costoEditor.option("format", `#0.##${nuovaValuta}`);

            // Anticipo
            const anticipoEditor = form.getEditor(`pagato_${cameraIdGen}`);
            if (anticipoEditor) anticipoEditor.option("format", `#0.##${nuovaValuta}`);

            // Totale
            const totaleEditor = form.getEditor(`costo_totale_${cameraIdGen}`);
            if (totaleEditor) totaleEditor.option("format", `#0.##${nuovaValuta}`);
              }
          }},

        ]}
    const pagamentoBox={ colCountByScreen:{lg: 2, xs: 1},
        colSpan:2,
        itemType:"group",
        name: `gruppoPagamento_${cameraIdGen}`,
        items:[
          {
        dataField: `metodo_${cameraIdGen}`,
        label:{text:dizionarioTraduzioni(lingua,"Metodo di Pagamento")},
          editorType: "dxTextBox",
          editorOptions: {
            value:metodopag,
          }},
            {
        dataField: `datapag_${cameraIdGen}`,
        label:{text:dizionarioTraduzioni(lingua,"Data del Pagamento")},
          editorType: "dxDateBox",

          editorOptions: {
            value:datapag?DateTime.fromFormat(datapag,"yyyyMMdd").toJSDate():null,
            displayFormat: "dd/MM/yyyy",
          }},

        ]}
    const costoBox={ colCountByScreen:{lg: 3, xs: 3},
        colSpan:2,
        itemType:"group",
        name: `gruppoMateriale_${cameraIdGen}`,
        items:[
          {
        dataField: `costo_p_${cameraIdGen}`,
        label:{text:dizionarioTraduzioni(lingua,"Costo")},
          editorType: "dxNumberBox",
          editorOptions: {
          value:costoG,
          format:`#0.##${valuta?convertiValuta(valuta):"€"}`,
          onValueChanged:function(e){
            if (form.option("formData")[`tipoCosto_${cameraIdGen}`]===1){
                const costoTotale=form.option("formData").val_durata*e.value
                form.updateData(`costo_totale_${cameraIdGen}`, costoTotale)
            }
            else{
                const costoTotale=e.value
                form.updateData(`costo_totale_${cameraIdGen}`, costoTotale)
            }
          }
          }},
          {
        dataField: `tipoCosto_${cameraIdGen}`,
        label:{text:"Tipo Costo"},
          editorType: "dxSelectBox",
          editorOptions: {
          value:1,
          dataSource:[{"ID":1,"name":dizionarioTraduzioni(lingua,"Al giorno")},{"ID":2,name:dizionarioTraduzioni(lingua,"Totale")}],
          valueExpr:"ID",
          displayExpr:"name",
          onValueChanged:function(e){

            if (e.value===1){

                const costoTotale=form.option("formData").val_durata*form.option("formData")[`costo_p_${cameraIdGen}`]
                form.updateData(`costo_totale_${cameraIdGen}`, costoTotale)
            }
            else{
                const costoTotale=form.option("formData")[`costo_p_${cameraIdGen}`]
                form.updateData(`costo_totale_${cameraIdGen}`, costoTotale)
            }
          }
          }},
          {
        dataField: `costo_totale_${cameraIdGen}`,
        label:{text:dizionarioTraduzioni(lingua,"Costo Totale")},
          editorType: "dxNumberBox",
          editorOptions: {
          value:form.option("formData").val_durata*costoG,
          readOnly:true,
          format:`#0.##${valuta?convertiValuta(valuta):"€"}`,
          }},

          ]
        }
    camereItems.splice(camereItems.length - 1, 0, costoBox);
    camereItems.splice(camereItems.length - 1, 0, anticipoBox);
    camereItems.splice(camereItems.length - 1, 0, pagamentoBox);
  form.itemOption("camereContainer", "items",camereItems);
  let contatore=1
  for (let oggetto of camereItems){
    if (oggetto.name && oggetto.name.startsWith("cameraBlock")){
    const numeroOr = parseInt(oggetto.name.split("_")[1])
        if (parseInt(($(`#cameraTitle_${numeroOr}`).text()).split(".")[1])!==contatore){
            $(`#cameraTitle_${numeroOr}`).text(`${dizionarioTraduzioni(lingua,"Camera N")}. ${contatore}`)
        }
        contatore++
    }
  }
}
function rimuoviCamera(name) {
const numeroT = parseInt(name.replace("cameraBlock_", ""));
const chiavi = [
  `camera_${numeroT}`,
  `pagato_${numeroT}`,
    `valuta_${numeroT}`,
    `metodo_${numeroT}`,
    `datapag_${numeroT}`,
  `costo_p_${numeroT}`,
  `ospiti_${numeroT}`,
  `costo_totale_${numeroT}`,
  `tipoCosto_${numeroT}`
];

// Rimuovi dal formData vero
chiavi.forEach(k => {
  form.updateData(k, undefined);
  delete form.option("formData")[k];
});

// Reimposta gli items del container
let oggetti = form.itemOption("camereContainer").items;
oggetti = oggetti.filter(o =>
  o.name !== name &&
  o.name !== `gruppoMateriale_${numeroT}` &&
  o.name !== `gruppoAnticipo_${numeroT}` && o.name !== `gruppoPagamento_${numeroT}`
);
form.itemOption("camereContainer", "items", oggetti);

let contatore=1
  for (let oggetto of oggetti){
    if (oggetto.name && oggetto.name.startsWith("cameraBlock")){
    const numeroOr = parseInt(oggetto.name.split("_")[1])
        if (parseInt(($(`#cameraTitle_${numeroOr}`).text()).split(".")[1])!==contatore){
            $(`#cameraTitle_${numeroOr}`).text(`${dizionarioTraduzioni(lingua,"Camera N")}. ${contatore}`)
        }
        contatore++
    }
  }
}
  setTimeout(() => {
    const popup = e.popup;
    let items = popup.option("toolbarItems") || [];

    items = items.map(item => {
      const sc = item.shortcut;
      item.options = item.options || {};

      // Bottone "Annulla"
      if (sc === "cancel") {
        const oldOnClick = item.options.onClick
        item.options.text = "Annulla";
        item.options.onClick = function (ev) {
          if (typeof oldOnClick === "function") {
            oldOnClick.call(this, ev); // Comportamento nativo
            let oggetti=form.itemOption("camereContainer").items
            oggetti = oggetti.filter(o => !(!(o.name && (o.name.startsWith("cameraBlock_") || o.name.startsWith("gruppoAnticipo_") ||o.name.startsWith("gruppoMateriale_") || o.name.startsWith("gruppoPagamento_")))));
            form.itemOption("camereContainer", "items", oggetti);

          } else {
            popup.hide(); // Fallback
            let oggetti=form.itemOption("camereContainer").items
            oggetti = oggetti.filter(o => !(o.name && (o.name.startsWith("cameraBlock_") || o.name.startsWith("gruppoAnticipo_") ||o.name.startsWith("gruppoMateriale_") || o.name.startsWith("gruppoPagamento_"))));
            form.itemOption("camereContainer", "items", oggetti);
          }
        };
      }

      // Bottone "Salva"
      if (sc === "done") {
        const oldOnClick = item.onClick;
        item.options.text = "Salva";
        if (typeof oldOnClick === "function") {
          item.options.onClick = function (ev) {
            let oggetti=form.itemOption("camereContainer").items
            oggetti = oggetti.filter(o => !(o.name && (o.name.startsWith("cameraBlock_") || o.name.startsWith("gruppoAnticipo_") ||o.name.startsWith("gruppoMateriale_") || o.name.startsWith("gruppoPagamento_"))));
            form.itemOption("camereContainer", "items", oggetti);
            oldOnClick.call(this, ev); // Mantieni submit/validazione nativa
          };
        }
      }

      return item;
    });

    // Applica gli items aggiornati alla toolbar
    popup.option("toolbarItems", items);
    form.option('items',ite)

  }, 0); // 0 ms è sufficiente per attendere inizializzazione della popup
  $("#loadingOverlay").hide()
},

onAppointmentAdded: async function (e){
    const data = e.appointmentData;
  // recupero ospiti di tutte le camere dinamiche
   const camereTot = Object.keys(data)
    .filter(key => key.startsWith("camera_"))
    .map(key => ({ camera: data[key],ospiti: data[key.replace("camera_", "ospiti_")],costoT:data[key.replace("camera_", "costo_totale_")],anticip:data[key.replace("camera_", "pagato_")],valut:data[key.replace("camera_", "valuta_")],metodd:data[key.replace("camera_", "metodo_")],datapag:data[key.replace("camera_", "datapag_")],}));
   let totaleCosto=0
   let totalePagato=0
   for (let camera of camereTot){
    totaleCosto+=camera.costoT
    totalePagato+=camera.anticip
   }
   if (e.appointmentData.transfer){
    totaleCosto+=e.appointmentData.incassoTransfer
    totalePagato+=e.appointmentData.pagatoTransfer
   }
   const datiPren={"bookingcheckindate":e.appointmentData.allDay?DateTime.fromJSDate(e.appointmentData.startDate, { zone: 'utc' }).toFormat("yyyyMMdd"):DateTime.fromJSDate(e.appointmentData.startDate, { zone: 'utc' }).toFormat("yyyyMMddHHmm"),"bookingcheckoutdate":e.appointmentData.allDay?DateTime.fromJSDate(e.appointmentData.endDate, { zone: 'utc' }).toFormat("yyyyMMdd"):DateTime.fromJSDate(e.appointmentData.endDate, { zone: 'utc' }).toFormat("yyyyMMddHHmm"),
   "bookingreference":e.appointmentData.text,"bookingstructure":e.appointmentData.struttura,"bookingstructure":e.appointmentData.struttura,"bookingnotes":e.appointmentData.description,"bookingtotcost":totaleCosto,"bookingadvancepaid":totalePagato
   }
   $("#loadingOverlay").show()
   var richiesta = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiPren,
               azione:'setBooking'})
   let idPre=richiesta.bookingid
   for (let camera of camereTot){
      const datiCame={"roomid":camera.camera,"bookingid":idPre,"linkbookroomcost":camera.costoT,"linkbookroomadvance":camera.anticip,"linkbookroomcurrency":camera.valut,"linkbookroompaymentmethod":camera.metodd,"linkbookroompaymentdate":camera.datapag?DateTime.fromJSDate(camera.datapag).toFormat("yyyyMMdd"):null}
      const richiestaC = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiCame,
               azione:'setLinkBookingRoom'})
      const idCam=richiestaC.linkbookroomid
      for (let ospite of camera.ospiti){
        const datiOsp={"linkbookroomid":idCam,"guestbirthplace":ospite.luogoNascita,"guestbirthdate":ospite.dataNascita,"guestdocnumber":ospite.numeroPassaporto,"guestdoctype":ospite.tipoDoc,"guestname":ospite.nome,"guestsurname":ospite.cognome,"guestnationality":ospite.nazionalita,"guestsex":ospite.sesso}
        const richiestaO = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiOsp,
               azione:'setBookingGuest'})
      }
   }
   if (e.appointmentData.transfer){
    const datiT={bookingid:idPre,extrapaid:e.appointmentData.pagatoTransfer,extratype:1,extravalue1:e.appointmentData.destinazioneTransfer,extracost:e.appointmentData.incassoTransfer,extracostus:e.appointmentData.costoTransfer}
    await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiT,
               azione:'setBookingExtra'})
   }
   $("#loadingOverlay").hide()

},
onAppointmentDeleted: async function(e){
     $("#loadingOverlay").show()
    let richiesta = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               delId:e.appointmentData.id,
               azione:'delBooking'})
    fetchData()
    $("#loadingOverlay").hide()

},
onAppointmentUpdated: async function(e){
    const data = e.appointmentData;
    console.log(data)
   const camereTot = Object.keys(data)
    .filter(key => key.startsWith("camera_"))
    .map(key => ({ linkbookroomid:data[key.replace("camera_", "linkbookroomid_")], camera: data[key],ospiti: data[key.replace("camera_", "ospiti_")],costoT:data[key.replace("camera_", "costo_totale_")],anticip:data[key.replace("camera_", "pagato_")],valut:data[key.replace("camera_", "valuta_")],metodd:data[key.replace("camera_", "metodo_")],datapag:data[key.replace("camera_", "datapag_")],}));
   let totaleCosto=0
   let totalePagato=0
   for (let camera of camereTot){
    totaleCosto+=camera.costoT
    totalePagato+=camera.anticip
   }
   if (e.appointmentData.transfer){
    totaleCosto+=e.appointmentData.incassoTransfer
    totalePagato+=e.appointmentData.pagatoTransfer
   }
   const datiPren={"bookingcheckindate":e.appointmentData.allDay?DateTime.fromJSDate(e.appointmentData.startDate, { zone: 'utc' }).toFormat("yyyyMMdd"):DateTime.fromJSDate(e.appointmentData.startDate, { zone: 'utc' }).toFormat("yyyyMMddHHmm"),"bookingcheckoutdate":e.appointmentData.allDay?DateTime.fromJSDate(e.appointmentData.endDate, { zone: 'utc' }).toFormat("yyyyMMdd"):DateTime.fromJSDate(e.appointmentData.endDate, { zone: 'utc' }).toFormat("yyyyMMddHHmm"),
   "bookingreference":e.appointmentData.text,"bookingstructure":e.appointmentData.struttura,"bookingnotes":e.appointmentData.description,"bookingtotcost":totaleCosto,"bookingadvancepaid":totalePagato
   }
   let richiesta = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiPren,
               setId:e.appointmentData.id,
               azione:'setBooking'})
   let camereDop=[]
   for (let camera of camereTot){
      camereDop.push(camera.linkbookroomid)
   }
   $("#loadingOverlay").show()
   let camereTot2=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLinkBookingRooms",
                filtri:{"bookingid":e.appointmentData.id}
            })
   let camereP=[]
   for (let camera of camereTot2){
      camereP.push(camera.linkbookroomid)
   }
   for (let camera of camereP){
      if (!(camereDop.includes(camera))){
        let richiestaC = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               delId:camera,
               azione:'delLinkBookingRoom'})
      }
   }
   for (let camera of camereTot){
    if (camera.linkbookroomid!==0){
       const datiCame={"roomid":camera.camera,"linkbookroomcost":camera.costoT,"linkbookroomadvance":camera.anticip,"linkbookroomcurrency":camera.valut,"linkbookroompaymentmethod":camera.metodd,"linkbookroompaymentdate":camera.datapag?DateTime.fromJSDate(camera.datapag).toFormat("yyyyMMdd"):null}
      const richiestaC = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiCame,
               setId:camera.linkbookroomid,
               azione:'setLinkBookingRoom'})
      for (let ospite of camera.ospiti){
        const datiOsp={"linkbookroomid":camera.linkbookroomid,"guestbirthplace":ospite.luogoNascita,"guestbirthdate":ospite.dataNascita,"guestdocnumber":ospite.numeroPassaporto,"guestdoctype":ospite.tipoDoc,"guestname":ospite.nome,"guestsurname":ospite.cognome,"guestnationality":ospite.nazionalita,"guestsex":ospite.sesso}
        if (ospite.guestid){
            const richiestaO = await funzione_collegamento({
                   userid: getUserId(),
                   token: getToken(),
                   logout_on_error: true,
                   valori:datiOsp,
                   setId:ospite.guestid,
                   azione:'setBookingGuest'})
        }
        else {
            const richiestaO = await funzione_collegamento({
                   userid: getUserId(),
                   token: getToken(),
                   logout_on_error: true,
                   valori:datiOsp,
                   azione:'setBookingGuest'})
        }
      }
    }
    else {
      const datiCame={"roomid":camera.camera,"linkbookroomcost":camera.costoT,"linkbookroomadvance":camera.anticip,"linkbookroomcurrency":camera.valut,"linkbookroompaymentmethod":camera.metodd,"linkbookroompaymentdate":camera.datapag?DateTime.fromJSDate(camera.datapag).toFormat("yyyyMMdd"):null,bookingid:e.appointmentData.id}
      const richiestaC = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiCame,
               azione:'setLinkBookingRoom'})
      const idCam=richiestaC.linkbookroomid
      for (let ospite of camera.ospiti){
        const datiOsp={"linkbookroomid":idCam,"guestbirthplace":ospite.luogoNascita,"guestbirthdate":ospite.dataNascita,"guestdocnumber":ospite.numeroPassaporto,"guestdoctype":ospite.tipoDoc,"guestname":ospite.nome,"guestsurname":ospite.cognome,"guestnationality":ospite.nazionalita,"guestsex":ospite.sesso}
        const richiestaO = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori : datiOsp,
               azione:'setBookingGuest'})
      }
    }
   }
   let extra=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBookingExtras",
                filtri:{"bookingid":e.appointmentData.id}
   })
   let transferCera=false
   for (let i in extra){
      if (i.extratype===1){
          transferCera=i.extraid
      }
   }
   if (e.appointmentData.transfer){
       if (e.appointmentData.transferid){
        const datiT={extratype:1,extrapaid:e.appointmentData.pagatoTransfer,extravalue1:e.appointmentData.destinazioneTransfer,extracost:e.appointmentData.incassoTransfer,extracostus:e.appointmentData.costoTransfer}
        await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiT,
               setId:e.appointmentData.transferid,
               azione:'setBookingExtra'})
       }
       else{
          const datiT={bookingid:e.appointmentData.id,extrapaid:e.appointmentData.pagatoTransfer,extratype:1,extravalue1:e.appointmentData.destinazioneTransfer,extracost:e.appointmentData.incassoTransfer,extracostus:e.appointmentData.costoTransfer}
          await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:datiT,
               azione:'setBookingExtra'})
       }
   }
   else{
    if (transferCera!==false){
        await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               delId:transferCera,
               azione:'delBookingExtra'})
       }
   }

fetchData()
$("#loadingOverlay").hide()
},
      onAppointmentRendered: function (e) {
        const $el = e.appointmentElement;

  // Ottieni altezza dell'elemento
  const height = $el.outerHeight();

  // Calcola font-size proporzionale, con limiti min/max
  const fontSize = Math.max(10, Math.min(14, height * 0.6));

  $el.css({
    backgroundColor: "#3a86ff",
    color: "#fff",
    borderRadius: "4px",
    padding: "0px 0px",
    fontSize: `${fontSize}px`,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  });

  // Assicurati che il testo venga reinserito (in caso venga rimosso dal rendering)
  $el.text(e.appointmentData.text);
        const camera = e.appointmentData.roomid;

        if (camera === 7) {
          e.appointmentElement.css("backgroundColor", "#FA0000"); // rosso
          e.appointmentElement.css("color", "#fff");
        } else if (camera === 6) {
          e.appointmentElement.css("backgroundColor", "#FF962E"); // blu
          e.appointmentElement.css("color", "#fff");
        }
        else if (camera === 5) {
          e.appointmentElement.css("backgroundColor", "#FFEF5C"); // blu
          e.appointmentElement.css("color", "#fff");
        }
        else if (camera === 4) {
          e.appointmentElement.css("backgroundColor", "#25DA43"); // blu
          e.appointmentElement.css("color", "#fff");
        }
        else if (camera === 3) {
          e.appointmentElement.css("backgroundColor", "#ADADAD"); // blu
          e.appointmentElement.css("color", "#fff");
        }
        else if (camera === 1) {
          e.appointmentElement.css("backgroundColor", "#252EDA"); // blu
          e.appointmentElement.css("color", "#fff");
        }
        else if (camera === 8) {
          e.appointmentElement.css("backgroundColor", "#AD1D7B"); // blu
          e.appointmentElement.css("color", "#fff");
        }

      }

      })
      fetchData()
},[])

const fetchData = async () => {
        $("#loadingOverlay").show()
        let totaleOre=0


        const utenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getUsers",
            })
        let date=$("#schedulerElementPrenotazioni").dxScheduler("instance").getStartViewDate()

        date=date.toISOString()
        date=convertDate(DateTime.fromISO(date))
        let date2=$("#schedulerElementPrenotazioni").dxScheduler("instance").getEndViewDate()

        date2=date2.toISOString()
        if ($("#schedulerElementPrenotazioni").dxScheduler("instance").option("currentView")!=="day")
        date2=convertDate(DateTime.fromISO(date2).plus({days:1}))
        else date2=convertDate(DateTime.fromISO(date2))
        const dt1 = DateTime.fromFormat(date, "yyyyLLdd");
        const dt2 = DateTime.fromFormat(date2, "yyyyLLdd");

        if (dt1.hasSame(dt2, 'day')) {
          const dt2Plus1 = dt2.plus({ days: 1 });
          date2= dt2Plus1.toFormat("yyyyLLdd");
        }
        const prenotazioni = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBookings",
                filtri:getUserId()=="34"?{bookingstructure:2}:null

            })
        let camere1=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBookingRooms",
                filtri:getUserId()==="34"?{roomstructure:2}:null
            })
        const prenotazioniCamere=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLinkBookingRooms",

            })

        let prenotazoniForm=[]
        if (prenotazioni.length>0){
            for (let prenotazione of prenotazioni){
                for (let camerapr of prenotazioniCamere){
                    if (prenotazione.bookingid===camerapr.bookingid){
                        prenotazoniForm.push({
                            id:prenotazione.bookingid,
                            text: prenotazione.bookingreference,
                            startDate: new Date(convertDate(prenotazione.bookingcheckindate).toISO({ includeOffset: false })+"Z"),
                            endDate: new Date(convertDate(prenotazione.bookingcheckoutdate).toISO({ includeOffset: false })+"Z"),
                            camera:camerapr.roomdescr,
                            roomid:camerapr.roomid,
                            struttura:prenotazione.bookingstructure
                       })

                    }
                }
        }
        }
        let risorse=[]
    const isVilla = d => /^villa\s*\d+/i.test(d);

const parseVilla = d => {
  const m = d.match(/villa\s*(\d+)([a-z]?)/i);
  return { n: +m[1], l: m[2] || '' };
};

// raccolgo le ville SENZA filtrare l'array
const camere = [];
for (const c of camere1) {
  if (isVilla(c.roomdescr)) camere.push(c);
}

// ordino solo le ville
camere.sort((a, b) => {
  const A = parseVilla(a.roomdescr);
  const B = parseVilla(b.roomdescr);
  return A.n - B.n || A.l.localeCompare(B.l);
});

// rimpiazzo solo le ville, il resto NON SI TOCCA
let k = 0;
for (let i = 0; i < camere1.length; i++) {
  if (isVilla(camere1[i].roomdescr)) {
    camere1[i] = camere[k++];
  }
}
let inizio=0
for (let camera of camere1){
    if (!camere.includes(camera)){
        camere.splice(inizio,0,camera)
        inizio+=1
    }
}
        for (let i of camere) {
            if (i.roomusable)
            risorse=[...risorse,{id:i.roomid,text:i.roomdescr,}]
        }
        $("#schedulerElementPrenotazioni").dxScheduler("instance").option("resources",[{
          fieldExpr: "roomid",
          dataSource: risorse,
          label: "Camera"
        }])
    $("#schedulerElementPrenotazioni").dxScheduler("instance").option("groups", ["roomid"])
       $("#schedulerElementPrenotazioni").dxScheduler("instance").option("dataSource",prenotazoniForm)
       $("#loadingOverlay").hide()

}


return <div>
            <h2>{dizionarioTraduzioni(lingua, "Agenda Prenotazioni")}</h2>
            <div id="schedulerElementPrenotazioni" className="agendaScheduler" style={{borderRadius:"15px",border:"0px solid black"}}/>
            <div id="loadingOverlay">
              <div className="spinner">
                <Lottie  style={{ width: "250px", height: "250px" }} animationData={animLoading} loop={true} />
              </div>
            </div>
         </div>
}
export default AgendaPrenotazioni;